import i18n from 'i18next';
import {getCurrentLocale} from 'utils/common';
import {AgreementClause} from '@guestapp/sdk';
import {AgreementClauseKeyFormName} from 'utils/guestForm/constants';

export function getAgreementClausesData(agreementClause: AgreementClause) {
  const language = getCurrentLocale().toUpperCase();
  const body = agreementClause.body_translations[language] || agreementClause.body;

  return {
    body,
    name: `${AgreementClauseKeyFormName}${agreementClause.id}`,
    required: agreementClause.is_required
      ? i18n.t('cheking_this_clause_is_required')
      : false,
  };
}
